
export function isNullOrEmpty(s: string) {
    return s == null || s === "";
}